// frontend/src/services/dashboardAPI.ts
// (Anteriormente salesAPI.ts)
import api from '../../../services/apiConfig';
import { DatePreset } from '../../../stores/filterStore';

// --- INTERFACES  ---
export interface SaleData {
    DATA: string;
    Vendedor: string;
    Venda: number;
    Margem: number;
    Item: string;
    Nome_Cliente_Completo: string;
    CARTEIRA: string;
    ESTADO: string;
    CIDADE_CLIENTE: string;
    Linha: string;
    BASE: number;
    BaseId: number;
    QUANT: number;
    ClientId: number;
}
export interface PeriodMetrics {
    totalVendas: number;
    numeroVendas: number;
    totalMargem: number;
}
export interface GoalData {
    BASE: number;
    goal: number;
    marginGoal: number;
    scoreFinal?: number;
    percVenda?: number;
    percMargem?: number;
    percMix?: number;
    pesoVenda?: number;
    pesoMargem?: number;
    pesoMix?: number;
}

export interface MonthlyGoal {
    mes: number;
    meta: number;
    scoreFinal?: number;
    percVenda?: number;
    percMargem?: number;
    percMix?: number;
}

export interface InactiveClientData {
    name: string;
    ultimaCompra: string;
    totalHistorico: number;
}

export interface ChartPoint {
    x: string;
    y: number;
}
export interface TrendChartData {
    [key: string]: {
        current: ChartPoint[];
        previous: ChartPoint[];
    }
}
export interface APIResponseData {
    salesData: SaleData[];
    trendChartData: TrendChartData;
    previousPeriodMetrics: PeriodMetrics;
    reactivatedClientsCount?: number;
    reactivatedClientsRevenue?: number;
    newClientsCount?: number;
    newClientsRevenue?: number;
    inactiveClients?: InactiveClientData[];
    reactivatedClientsList?: { nome: string; valor: number; ultimaCompra: string; doc?: string }[];
    newClientsList?: { nome: string; valor: number; ultimaCompra: string; doc?: string }[];
    previousLineRevenue?: { Linha: string; totalVenda: number; }[];
    cached?: boolean;
    cachedAt?: string;
}
export interface Carteira {
    ID: number;
    BASE: string;
}
export interface GoalsAPIResponse {
    goals: GoalData[];
    cached?: boolean;
    cachedAt?: string;
}

export interface NotificationItem {
    id: string;
    type: 'sale' | 'goal' | 'client' | 'product' | 'alert';
    title: string;
    description: string;
    time: string;
    read: boolean;
}


// --- FUNÇÕES DE FETCH (Rotas Corrigidas para /dashboard) ---

/**
 * Busca a lista de carteiras do supervisor logado.
 */
export const fetchCarteiras = () => {
    // Rota corrigida: /sales/carteiras -> /dashboard/carteiras
    return api.get<Carteira[]>('/dashboard/carteiras');
};

/**
 * Busca os dados de vendas e tendências para o dashboard.
 */
export const fetchSalesData = (dataI: string, dataF: string, carteiraId?: string, preset?: DatePreset, refresh?: boolean) => {
    // Rota corrigida: /sales/sales-data -> /dashboard/sales-data
    return api.get<APIResponseData>('/dashboard/sales-data', {
        params: { dataI, dataF, carteiraId, preset, refresh: refresh ? 'true' : undefined }
    });
};

/**
 * Busca as metas para o dashboard. (Metas de VENDEDOR)
 */
export const fetchGoalsData = (dataI: string, dataF: string, carteiraId?: string, refresh?: boolean) => {
    // Rota corrigida: /sales/goals -> /dashboard/goals
    return api.get<GoalsAPIResponse>('/dashboard/goals', {
        params: { dataI, dataF, carteiraId, refresh: refresh ? 'true' : undefined }
    });
};

/**
 * Busca as metas para o dashboard. (Metas de SUPERVISOR)
 */
export const fetchMonthlyGoalsData = async (year: number, carteiraId?: string) => {
    const params: any = { year };
    if (carteiraId) params.carteiraId = carteiraId;
    const res = await api.get('/dashboard/monthly-goals', { params });
    return res.data as { monthlyGoals: MonthlyGoal[] };
};

export const fetchSupervisorGoalsData = (dataI: string, dataF: string) => {
    // Rota nova: /dashboard/supervisor-goals
    return api.get<GoalsAPIResponse>('/dashboard/supervisor-goals', {
        params: { dataI, dataF }
    });
};

/**
 * Busca as metas para o dashboard. (Metas de GERENTE REGIONAL)
 */
export const fetchGerenteGoalsData = (dataI: string, dataF: string) => {
    return api.get<GoalsAPIResponse>('/dashboard/gerente-goals', {
        params: { dataI, dataF }
    });
};

/**
 * Busca notificações (ex: pedidos atrasados)
 */
export const fetchNotifications = () => {
    return api.get<NotificationItem[]>('/dashboard/notifications');
};